import React from 'react';
import man from '../../images/Courier-Man.png'
import './Cost.css'

const Cost = () => {
    return (
        <div className='mt-5'>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-md-6">
                        <img src={man} className='w-50' alt="" />
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                <label className='title-height' htmlFor="">height (cm)</label>
                            </div>
                            <div className="col-md-9">
                                <input className='cost-field form-control' type="text" />
                            </div>

                            
                            <div className="col-md-3 mt-4 d-flex justify-content-center align-items-center">
                                <label className='title-height' htmlFor="">width (cm)</label>
                            </div>
                            <div className="col-md-9 mt-4">
                                <input className='cost-field form-control' type="text" />
                            </div>


                            <div className="col-md-3 mt-4 d-flex justify-content-center align-items-center">
                                <label className='title-height' htmlFor="">depth (cm)</label>
                            </div>
                            <div className="col-md-9 mt-4">
                                <input className='cost-field form-control' type="text" />
                            </div>


                            <div className="col-md-3 mt-4 d-flex justify-content-center align-items-center">
                                <label className='title-height' htmlFor="">weight (KG)</label>
                            </div>
                            <div className="col-md-9 mt-4">
                                <input className='cost-field form-control' type="text" />
                            </div>

                            <div className="col-md-3 mt-4 d-flex justify-content-center align-items-center">
                                <label className='title-height' htmlFor="">package</label>
                            </div>
                            <div className="col-md-9 mt-4">
                                <input className='cost-field form-control' type="text" />
                            </div>

                            <input className='w-25 mt-4 cost-btn m-auto' type="submit" />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cost;